export type PayoutFrequency = 'monthly' | 'quarterly' | 'on_close';

export interface CommissionSettingsDTO {
  payout_frequency: PayoutFrequency;
  payout_threshold_amount: number;
  retainer_min_duration_months: number;
  default_currency: string;
  fiscal_year_start_month: number;
  notify_on_commission_created: boolean;
  notify_on_commission_paid: boolean;
  approval_required_above_amount?: number;
  version: number;
  updated_at: Date;
}

export interface UpdateCommissionSettingsDTO {
  payout_frequency?: PayoutFrequency;
  payout_threshold_amount?: number;
  retainer_min_duration_months?: number;
  default_currency?: string;
  fiscal_year_start_month?: number;
  notify_on_commission_created?: boolean;
  notify_on_commission_paid?: boolean;
  approval_required_above_amount?: number;
}

export const PAYOUT_FREQUENCY_OPTIONS: { value: PayoutFrequency; label: string }[] = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'on_close', label: 'On Close' },
];

export const FISCAL_MONTH_OPTIONS = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
];
